//@ts-check
import { Card } from '@react/react-spectrum/Card';
import styled from 'styled-components';

/**
 * react-spectrum Card overriden with custom styles
 * @property {boolean} [$roundedBottom=true] - (un)set the bottom corners rounded
 * @property {boolean} [$roundedTop=true] - (un)set the top corners rounded
 */
export const StyledCard = styled(Card)`
  width: 100%;
  justify-content: space-between;
  border-bottom-left-radius: ${({ $roundedBottom }) => ($roundedBottom ? '4px' : '0px')};
  border-bottom-right-radius: ${({ $roundedBottom }) => ($roundedBottom ? '4px' : '0px')};
  border-top-left-radius: ${({ $roundedTop }) => ($roundedTop ? '4px' : '0px')};
  border-top-right-radius: ${({ $roundedTop }) => ($roundedTop ? '4px' : '0px')};
`;

/**
 * @typedef {Object} StyledDivProps
 * @property {boolean} $isMobileSized - if or not the full text is displayed
 *
 * custom CardBody based on the react-spectrum one
 */
export const CardBody =
  /** @type {import('styled-components').ThemedStyledFunction<'div', StyledDivProps>}*/
  (styled.div)`
    display: flex;
    flex-direction: ${({ $isMobileSized }) => ($isMobileSized ? 'column' : 'row')};
    justify-content: space-between;
    align-items: ${({ $isMobileSized }) => ($isMobileSized ? 'stretch' : 'center')};
    height: 100%;
    padding: 16px;
  `;

/**
 * container with padding and a fixed size for images
 */
export const ImageContainer = styled.div`
  width: 60px;
  height: 60px;
  margin-right: var(--spectrum-global-dimension-size-125);
  & img {
    border-radius: 4px;
  }
`;

/**
 * styled title element
 */
export const TitleElement = styled.h3`
  margin: 0;
  font-size: 16px;
  font-weight: bold;
  line-height: 1.25;
  color: var(--spectrum-global-color-static-gray-900);
  word-wrap: anywhere;
`;

/**
 * styled company element
 */
export const PublisherElement = styled.span`
  font-size: 12px;
  color: var(--spectrum-global-color-static-gray-600);
`;

/**
 * @typedef {Object} StyledSpanProps
 * @property {boolean} [$showMore=false] - if or not the full text is displayed
 * @property {number} [$lines=3] - number of lines to show
 *
 * styled description element
 */
export const DescriptionElement =
  /**@type {import('styled-components').ThemedStyledFunction<'span', StyledSpanProps>} */
  (styled.span)`
    font-size: 14px;
    color: var(--spectrum-global-color-static-gray-800);
    margin-bottom: 6px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: ${({ $showMore = false, $lines = 3 }) => ($showMore ? 'unset' : $lines)};
    word-wrap: anywhere;
    &&&& {
      + button > span {
        padding: 0;
        color: var(--spectrum-accent-color-1000);
        cursor: pointer;
        text-decoration: underline;
      }
    }
  `;

/**
 * purple badge for Firefly apps
 */
export const Badge = styled.span`
  padding: 4px 10px;
  background-color: #5c5ce0;
  font-size: 12px;
  color: var(--spectrum-global-color-static-gray-50);
  border-radius: 4px;
`;

export const SupportedProductIcon = styled.svg`
  width: 18px;
  height: 18px;
`;
